export interface ToAddressParams {
  town: string | undefined;
  building: string | undefined;
  floor?: string;
  short?: boolean;
  skipFloorLabel?: boolean;
}

export const toAddress = ({
  town = 'Город',
  building = 'офис',
  floor,
  short,
  skipFloorLabel,
}: ToAddressParams): string => {
  if (short || !floor) return `${town}, ${building}`;

  if (skipFloorLabel) {
    return `${town}, ${building}, ${floor}`;
  }

  return `${town}, ${building}, этаж ${floor}`;
};
